import matchSorter from 'match-sorter';
import sortBy from 'lodash.sortby';
import csvExporter from './csv-exporter';

export default class Pager {
  keysToSearch = [];
  search = '';
  sortData = null;
  pageSize = 10;
  currentPage = 1;

  constructor(keysToSearch, exportDefinitions) {
    this.keysToSearch = keysToSearch;
    this.exportDefinitions = exportDefinitions;
  }

  filter(list) {
    if (
      !this.search ||
      !this.keysToSearch ||
      !this.keysToSearch.length
    ) {
      return list;
    }

    return matchSorter(list, this.search, {
      keys: this.keysToSearch,
      threshold: matchSorter.rankings.CONTAINS
    });
  }

  sortChange(sortData) {
    this.sortData = sortData || null;
  }

  pageSizeChange(pageSizeData) {
    this.pageSize = pageSizeData || 10;
  }

  slice(list) {
    const currentPageToSlice = this.currentPage - 1;
    return list.slice(
      currentPageToSlice * this.pageSize,
      (currentPageToSlice + 1) * this.pageSize
    );
  }

  sort(list) {
    if (
      !this.sortData ||
      !this.sortData.prop ||
      !this.sortData.order
    ) {
      return list;
    }

    if (this.sortData.order === 'descending') {
      return sortBy(list, [this.sortData.prop]).reverse();
    }

    return sortBy(list, [this.sortData.prop]);
  }

  exportToCsv(fullList) {
    if (!this.hasDataToExport(fullList)) {
      throw new Error('No config/data to CSV export!');
    }

    return csvExporter.download(
      this.exportDefinitions,
      this.filteredAndSortedList(fullList)
    );
  }

  hasDataToExport(fullList) {
    if (
      !this.exportDefinitions ||
      !this.exportDefinitions.length
    ) {
      return false;
    }

    return !!this.filteredAndSortedList(fullList).length;
  }

  filteredAndSortedList(fullList) {
    return this.sort(this.filter(fullList));
  }

  paginate(fullList) {
    return this.slice(this.filteredAndSortedList(fullList));
  }
}



// WEBPACK FOOTER //
// ./src/shared/pager/pager.js